import config from '../../config/app';



export const isProd = config.env === 'prod';
